import { useStrategies } from "@/hooks/api";
import { Link } from "react-router-dom";

/**
 * 상태 스트립의 집행 표식 — "지금 실주문을 낼 수 있는 규칙이 있는가".
 *
 * 장 상태·연결 상태 옆에 없던 한 가지예요. 셋 다 초록이어도 활성 규칙이 0개면 아무것도
 * 사지 않고, 전체 정지를 누르면 규칙이 전부 `PAUSED` 가 되므로 이 표식도 같이 꺼집니다
 * (킬스위치가 상태를 바꾸는 유일한 경로라 따로 묻지 않아요).
 *
 * 켜져 있을 때만 점이 느리게 숨 쉬어요(`styles/tranche.css` 의 `.tranche-pulse`). 쉬는
 * 동안 화면에서 움직이는 건 이 점 하나뿐이고, 그건 장식이 아니라 상태입니다.
 * 색만으로 말하지 않아요 — 문장이 같은 내용을 적습니다.
 */
export function ExecutionBadge() {
  const { data, isLoading } = useStrategies();
  // 확인 중에도 자리를 잡아요(`ConnectionBadge` 의 "연결 확인 중" 과 같은 규약) — 늦게
  // 끼어들면 배지 줄이 그때 접혀서 크롬이 자라요.
  if (isLoading) {
    return (
      <span className="inline-flex min-h-6 items-center gap-1.5 px-1.5 py-0.5 text-caption-1 text-label-alternative">
        <span aria-hidden="true" className="h-2 w-2 shrink-0 rounded-full bg-fill-strong" />
        규칙 확인 중
      </span>
    );
  }
  if (!data) return null;
  const active = data.filter((item) => item.status === "ACTIVE").length;
  const live = active > 0;
  return (
    <Link
      to="/rules"
      className="apple-pressable inline-flex min-h-6 items-center gap-1.5 rounded-sm px-1.5 py-0.5 text-caption-1 text-label-neutral transition-colors duration-fast ease-standard hover:bg-fill-normal hover:text-label-strong"
    >
      <span
        aria-hidden="true"
        className={`h-2 w-2 shrink-0 rounded-full ${live ? "tranche-pulse bg-primary" : "bg-label-assistive"}`}
      />
      {live ? `규칙 ${active}개 실행 중` : "실행 중인 규칙 없음"}
    </Link>
  );
}
